export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const diffMs = Date.now() - d.getTime();
    const diffMin = Math.round(diffMs / 60000);
    if (diffMin < 1) return "just now";
    if (diffMin < 60) return `${diffMin}m ago`;
    const diffHr = Math.round(diffMin / 60);
    if (diffHr < 24) return `${diffHr}h ago`;
    const diffDay = Math.round(diffHr / 24);
    if (diffDay < 30) return `${diffDay}d ago`;
    return d.toISOString().slice(0, 10);
  } catch {
    return iso;
  }
}

export function extractHeadline(action: string | null | undefined): string {
  if (!action) return "";
  // First sentence or first 140 chars, whichever is shorter
  const firstStop = action.indexOf(". ");
  if (firstStop > 0 && firstStop < 140) return action.slice(0, firstStop + 1);
  if (action.length > 140) return action.slice(0, 137) + "…";
  return action;
}
